<template>
  <div>
    <div class="flex flex-wrap sm:flex-nowrap sm:flex-row bg-slate-100 w-full p-4 mb-6 ">
        <div class="mx-auto w-[1000px] flex justify-between">
          <div class="w-full flex-col sm:flex-row text-center flex justify-center sm:justify-start mb-3 sm:mb-0 text-center sm:text-left  sm:basis-4/12 md:basis-3/12 flex items-center">
            <div @click="show=false" class="gridview lowercase cursor-pointer" :class="{ 'text-darkRed': show === false }">
              <div class="flex justify-center items-center w-10 h-10 bg-black  rounded-full mr-1" :class="{ 'bg-darkRed': show === false }">
                <img src="/row.svg" alt="event" class="w-5 h-5 ">
              </div>
            </div>
            <p class="uppercase mr-1 font-semibold sm:text-tiny md:text-base" :class="{ 'text-darkRed': show === false }">list view</p>



          </div>
          <div class="w-full flex-col sm:flex-row flex mb-3 sm:mb-0 sm:basis-6/12 text-center" >

            <div v-if="show">
              <div class="flex justify-center items-center mt-2">
                <div class="flex ml-6">
                  <button @click="showCalendar('prev')">
                    <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>
                  <button @click="showCalendar('next')">
                    <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
                <h2 class="ml-2 text-xl font-bold leading-none">{{ currentDate.toLocaleString('default', {    timeZone: 'utc', month: 'long' }) }}, {{ currentDate.getFullYear() }}</h2>
              </div>
            </div>


            <template v-if="!show">
              <select @change="scrollToItem" v-model="month" class="py-2 px-3 border focus:outline-none focus:ring-slate-500 focus:border-slate-500">
                <option v-for="item in months" :value="item.id">{{ item.name }}</option>
              </select>

              <select v-model="year" class="py-2 px-3 border focus:outline-none focus:ring-slate-500 focus:border-slate-500">
                <option v-for="item in years" :value="item">{{ item }}</option>

              </select>

              <button @click="getData"
                      class="bg-blackLight text-white mx-auto  uppercase sm:ml-1 py-2 px-3  w-full max-w-[153px] sm:w-auto mt-1 sm:mt-0"
              >go</button>

<!--              <div class="flex justify-between items-center">-->
<!--                <img src="/icons/left-arrow.svg" alt="arrow svg"  class="w-6 h-6">-->
<!--                <div v-for="item in months">-->
<!--                  {{ item.name }}-->
<!--                </div>-->
<!--                <div v-for="item in years" :value="item">-->
<!--                  {{ item }}-->
<!--                </div>-->
<!--                <img src="/icons/right-arrow.svg" alt="arrow svg"  class="w-6 h-6">-->
<!--              </div>-->
            </template>
          </div>
          <div class="w-full flex-col hidden sm:flex sm:flex-row text-center sm:basis-2/4 sm:basis-4/12 md:basis-3/12 flex justify-center sm:justify-end items-center">

            <div @click="show=true" class="listview lowercase cursor-pointer mr-1" :class="{ 'text-darkRed': show === true }">
              <div class="flex justify-center items-center w-10 h-10 bg-black rounded-full ml-1" :class="{ 'bg-darkRed': show === true }">
                <img src="/calendar.svg" alt="event" class="w-5 h-5 ">
              </div>
            </div>
            <p class="uppercase font-semibold sm:text-tiny md:text-xl" :class="{ 'text-darkRed': show === true }"> Calendar view</p>
          </div>
        </div>
    </div>
    <template v-if="ready">
    <div class="grid-layout mb-10 max-w-[1000px] mx-auto" v-if="!show"  ref="scrollable" >
      <div class="mb-5" v-for="(item,index) in months" :key="index" ref="itemRefs">
        <template v-if="item.shows.length > 0">
        <p class="uppercase text-3xl.5 text-blackLight border-b-2 border-black font-semibold font-titleSemiLight mb-2">{{item.name}}</p>
        <div class="flex flex-row border-b border-grayLight2 last:border-0" v-for="it in item.shows">
          <div class="w-[70px] sm:w-[100px] xl:basis-2/12 px-4 text-darkRed font-bold text-xs sm:text-lg py-2">
            {{it.duration}}
          </div>
          <div class="grow flex-col py-2 mr-1 sm:mr-0">
            <NuxtLink :to="'/event/view/'+it.permalink" class="cursor-pointer  capitalize sm:uppercase text-tiny md:text-4xl md:font-semibold sm:text-lg flex items-center">{{it.title}} <img v-if="it.aa" src="/icons/star.svg" class="ml-1 w-5 h-5" alt="star svg"></NuxtLink>
            <div class="flex mt-2">
              <img src="/icons/location.svg" class="w-4 h-4 mr-2" alt="location">
              <span class="capitalize text-xs sm:text-base">{{it.location}}</span>
            </div>
          </div>
          <div class="sm:w-[320px] py-2 flex justify-end">
            <a v-if="it.advertisement" :href="it.advertisement">
              <img src="/icons/view-ad.png" alt="entry_form" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
            </a>
            <a v-if="it.entry_form" :href="it.entry_form">
            <img src="/icons/entry_form.png" alt="entry_form" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
            </a>
            <a v-if="it.photo_link" :href="it.photo_link">
            <img  src="/icons/icon_d.png" alt="photo_link" class="w-8 h-8 mr-1 md:w-14 md:h-14 md:mr-2 cursor-pointer">
            </a>
            <a v-if="it.misc1" :href="it.misc1">
            <img src="/icons/pdf_flat.png" alt="misc1" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
            </a>
            <a v-if="it.misc2" :href="it.misc2">
            <img src="/icons/pdf_flat.png" alt="misc2" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
            </a>
            <a v-if="it.misc3" :href="it.misc3">
            <img src="/icons/pdf_flat.png" alt="misc3" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
            </a>
            <a v-if="it.misc4" :href="it.misc4">
            <img src="/icons/pdf_flat.png" alt="misc4" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
            </a>
            <a v-if="it.misc5" :href="it.misc5">
            <img src="/icons/pdf_flat.png" alt="misc5" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
            </a>
            <a v-if="it.prize_list" :href="it.prize_list">
            <img src="/icons/prize_list.png" alt="prize_list" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
            </a>
            <a v-if="it.show_schedule" :href="it.show_schedule">
            <img src="/icons/show_schedule.png" alt="show_schedule" class="w-8 h-8 mr-1  md:w-14 md:h-14 md:mr-2 cursor-pointer">
            </a>
          </div>
        </div>
        </template>
      </div>
    </div>
    <div v-else class="mb-10">
      <div class="text-gray-700">

        <!-- Component Start -->
        <div class="hidden sm:flex flex-grow overflow-auto">

          <div class="flex flex-col flex-grow">
            <div class="grid grid-cols-7 mt-4">
              <div class="pl-1 text-sm font-extrabold">Sunday</div>
              <div class="pl-1 text-sm font-extrabold">Monday</div>
              <div class="pl-1 text-sm font-extrabold">Tuesday</div>
              <div class="pl-1 text-sm font-extrabold">Wednesday</div>
              <div class="pl-1 text-sm font-extrabold">Thursday</div>
              <div class="pl-1 text-sm font-extrabold">Friday</div>
              <div class="pl-1 text-sm font-extrabold">Saturday</div>
            </div>
            <div class="grid flex-grow min-h-[50vh] w-full h-auto grid-cols-7 grid-rows-5 gap-px pt-px mt-1 bg-slate-100">

              <template  v-for="day in calendarDays">
                <div  v-if="day" class="relative flex flex-col bg-white group">
                  <span class="mx-2 my-1 text-xs font-bold">{{ day.day }}</span>
                  <NuxtLink v-for="show in day.available_events" :to="'/event/view/'+ show.permalink" :class="show.color_class" class="flex items-center flex-shrink-0 h-5 text-xs hover:bg-gray-200 hover:text-black mb-0.5 text-white">
                      <span class="ml-2 font-extrabold text-black leading-none">
                        <span v-if="show.date_start.getDate() === day.day ">{{show.title}}</span>
                      </span>
                  </NuxtLink>
                </div>
                <div v-else></div>
              </template>

            </div>
          </div>
        </div>
        <!-- Component End  -->
      </div>
    </div>
    </template>
    <template v-else>
      <loaders-spinner />
    </template>
  </div>

</template>
<script setup>
import {computed, ref} from "vue";
import {http} from "~/utils/http";
import {useSiteURL} from "~/composables/state";

const currentDate = ref(new Date());

const calendarDays = ref([]);

const showCalendar = async (type = '') => {
  if (type === 'prev') {
    currentDate.value = new Date(currentDate.value.getFullYear(), currentDate.value.getMonth() - 1, 1)
  }
  if (type === 'next') {
    currentDate.value = new Date(currentDate.value.getFullYear(), currentDate.value.getMonth() + 1, 1)
  }
  calendarDays.value = [];
  const daysInMonth = new Date(currentDate.value.getFullYear(), currentDate.value.getMonth() + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentDate.value.getFullYear(), currentDate.value.getMonth(), 1).getDay();
  const events = await getCalendarData(currentDate.value.getFullYear(), currentDate.value.getMonth());
  // Add null values for days before the first day of the month
  for (let i = 0; i < firstDayOfMonth; i++) {
    calendarDays.value.push(null);
  }
  // Add the dates for the current month
  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(currentDate.value.getFullYear(), currentDate.value.getMonth(), day);
    const weekday = date.toLocaleString('default', {    timeZone: 'utc',weekday: 'short'});
    const available_events = events.filter((item)=>
       day >= item.date_start.toLocaleString('default', {    timeZone: 'utc',day: 'numeric'}) && day <= item.date_end.toLocaleString('default', {    timeZone: 'utc',day: 'numeric'})
    );

    calendarDays.value.push({day, weekday,available_events});
  }
};

let show = ref(false);
let shows = ref([]);
let year = ref(new Date().getFullYear());
let years = ref([new Date().getFullYear(),new Date().getFullYear() +1 ,new Date().getFullYear() +2,new Date().getFullYear() +3]);
let month = ref(new Date().getMonth());
let months = ref([
  {
    id:0,
    name:'January',
    shows:[],
  }, {
    id:1,
    name:'February',
    shows:[],
  }, {
    id:2,
    name:'March',
    shows:[],
  }, {
    id:3,
    name:'April',
    shows:[],
  }, {
    id:4,
    name:'May',
    shows:[],
  }, {
    id:5,
    name:'June',
    shows:[],
  }, {
    id:6,
    name:'July',
    shows:[],
  }, {
    id:7,
    name:'August',
    shows:[],
  }, {
    id:8,
    name:'September',
    shows:[],
  }, {
    id:9,
    name:'October',
    shows:[],
  }, {
    id:10,
    name:'November',
    shows:[],
  }, {
    id:11,
    name:'December',
    shows:[],
  },
])
const siteURL = useSiteURL();
const ready = ref(false);
const itemRefs = ref([])
const scrollable = ref(null)
const  bgColors = ref([
  'bg-red-200',
  'bg-blue-200',

  'bg-green-200',
  'bg-green-700',

  'bg-yellow-200',
  'bg-yellow-700',

  'bg-purple-200',
  'bg-purple-700',

  'bg-orange-200',
  'bg-orange-700',

  'bg-amber-200',
  'bg-amber-700',

  'bg-yellow-200',
  'bg-yellow-700',

  'bg-lime-200',
  'bg-lime-700',

  'bg-cyan-200',
  'bg-cyan-700',

  'bg-indigo-200',
  'bg-indigo-700',

  'bg-violet-200',

]);
const scrollToItem = () => {
  const item = itemRefs.value[month.value];
  if(item){
    window.scrollTo(0, item.offsetTop);
  }
}

const getData = async () => {
  months.value.forEach((item)=>{
    item.shows = [];
  })
  try {
    await http
        .get("/api/event", {
          params: {
            calendar:true,
            year:year.value
          },
        })
        .then(async (response) => {
          response.data.events.forEach((item) => {
            let aa = !!item.aaq;
            months.value[new Date(item.date_start).getMonth()]?.shows.push({
              id: item.id,
              title: item.name,
              location: item.city + (item.state_province ? (', ' + item.state_province.abbreviation) : ''),
              date_start:new Date(item.date_start),
              date_end:new Date(item.date_end),
              duration: new Intl.DateTimeFormat('default', {    timeZone: 'utc',
                    month: 'numeric',
                    day: 'numeric'
                  }).format(new Date(item.date_start)) +
                  ' - ' + new Intl.DateTimeFormat('default', {    timeZone: 'utc',
                    month: 'numeric',
                    day: 'numeric'
                  }).format(new Date(item.date_end)),
              permalink: item.permalink,
              aa: aa,
              prize_list:item.prize_list? siteURL.value+ item.prize_list:null,
              show_schedule:item.show_schedule? siteURL.value+ item.show_schedule:null,
              entry_form:item.entry_form? siteURL.value+ item.entry_form:null,
              misc1:item.misc1?  siteURL.value+ item.misc1:null,
              misc2:item.misc2? siteURL.value+ item.misc2:null,
              misc3:item.misc3? siteURL.value+ item.misc3:null,
              misc4:item.misc4? siteURL.value+ item.misc4:null,
              misc5:item.misc5? siteURL.value+ item.misc5:null,
              advertisement:item.advertisement? siteURL.value+ item.advertisement:null,
              photo_link:item.result? (item.result.photo_link?? null):null,
            })
          });
        });
  } catch (e) {
    console.log(e.response.data.error);
  }
}

const getCalendarData = async (year,month) => {
  let data = [];
  try {
    await http
        .get("/api/event", {
          params: {
            calendar:true,
            year:year,
            month:month
          },
        })
        .then(async (response) => {
          response.data.events.forEach((item,index) => {
            data.push({
              id: item.id,
              title: item.name,
              date_start:new Date(item.date_start),
              date_end:new Date(item.date_end),
              permalink: item.permalink,
              color_class: bgColors.value[index]
            })
          });
        });
  } catch (e) {
    console.log(e.response.data.error);
  }
  return data;
}

const start = async () => {
  ready.value = true;
  await getData();
  ready.value = true;
  scrollToItem();
}

start();
showCalendar();
</script>
